import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=9630f726&scoped=true&"
import script from "./index.js?vue&type=script&lang=js&"
export * from "./index.js?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=9630f726&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9630f726",
  null
  
)

export default component.exports